export default "__VITE_ASSET__Nn0xnCf1__"